import React from "react";
import { Select, Button, Typography, Popconfirm } from "antd";
import { LessonMinimalResponse } from "../../../../types/api/getLesson";
import SortableList from "../../../SortableList";

const { Title } = Typography;
const { Option } = Select;

interface LessonSelected {
  id: number;
  title: string;
  _uid?: string;
}

interface CourseLessonsSelectorProps {
  selectedLessons: LessonSelected[];
  availableLessons: LessonMinimalResponse[];
  handleRemoveLesson: (index: number) => void;
  handleAddLessonAtIndex: (index: number) => void;
  handleLessonChange: (index: number, field: string, value: any) => void;
  handleReorderLessons: (lessons: LessonSelected[]) => void;
}

// Selector de lecciones del curso (filas ordenables con drag & drop).
// Compartido entre cursos normales y diagnósticos.
const CourseLessonsSelector: React.FC<CourseLessonsSelectorProps> = ({
  selectedLessons,
  availableLessons,
  handleRemoveLesson,
  handleAddLessonAtIndex,
  handleLessonChange,
  handleReorderLessons,
}) => {
  return (
    <div className="selectRow">
      <Title level={4}>Lecciones</Title>
      <SortableList
        items={selectedLessons}
        onReorder={handleReorderLessons}
        getId={(lesson) => lesson._uid ?? lesson.id}
        renderItem={(lesson, index, { dragHandle }) => (
          <div className="lessonRow">
            {dragHandle}
            <Select
              placeholder="Selecciona una lección"
              value={lesson.id || undefined}
              onChange={(value) => handleLessonChange(index, "id", value)}
              style={{ width: "60%" }}
            >
              {availableLessons
                .filter(
                  (availableLesson) =>
                    !selectedLessons.some(
                      (selected) =>
                        selected.id === availableLesson.id &&
                        selected.id !== lesson.id,
                    ),
                )
                .sort((a, b) => b.id - a.id)
                .map((availableLesson) => {
                  // Utilidad para obtener el grado
                  const getGrado = (lesson: any): string => {
                    if (!lesson || typeof lesson !== "object") return "-";
                    if (lesson.education_level === "KINDER")
                      return "Preescolar";
                    if (lesson.education_level === "PRIMARIA")
                      return "Primaria";
                    return "-";
                  };
                  return (
                    <Option key={availableLesson.id} value={availableLesson.id}>
                      {availableLesson.id} - {getGrado(availableLesson)} -{" "}
                      {availableLesson.title}
                    </Option>
                  );
                })}
            </Select>
            <Popconfirm
              title="¿Eliminar esta lección?"
              description="Se eliminará la lección de la lista del curso."
              onConfirm={() => handleRemoveLesson(index)}
              okText="Sí"
              cancelText="No"
            >
              <Button type="text" danger style={{ marginLeft: "1rem" }}>
                Eliminar
              </Button>
            </Popconfirm>
            <Button
              type="dashed"
              onClick={() => handleAddLessonAtIndex(index + 1)}
              style={{ marginLeft: "1rem" }}
            >
              + Agregar Abajo
            </Button>
          </div>
        )}
      />
      <Button
        type="dashed"
        onClick={() => handleAddLessonAtIndex(selectedLessons.length)}
        style={{ marginTop: "1rem" }}
      >
        + Agregar Lección
      </Button>
    </div>
  );
};

export default CourseLessonsSelector;
